import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'Aspect';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3 3.75C3 3.33579 3.33579 3 3.75 3H20.25C20.6642 3 21 3.33579 21 3.75V20.25C21 20.6642 20.6642 21 20.25 21H3.75C3.33579 21 3 20.6642 3 20.25V3.75ZM4.5 4.5V19.5H19.5V4.5H4.5ZM6 6.75C6 6.33579 6.33579 6 6.75 6H9.75C10.1642 6 10.5 6.33579 10.5 6.75C10.5 7.16421 10.1642 7.5 9.75 7.5H8.56066L11.0303 9.96967C11.3232 10.2626 11.3232 10.7374 11.0303 11.0303C10.7374 11.3232 10.2626 11.3232 9.96967 11.0303L7.5 8.56066V9.75C7.5 10.1642 7.16421 10.5 6.75 10.5C6.33579 10.5 6 10.1642 6 9.75V6.75ZM12.9697 12.9697C13.2626 12.6768 13.7374 12.6768 14.0303 12.9697L16.5 15.4393V14.25C16.5 13.8358 16.8358 13.5 17.25 13.5C17.6642 13.5 18 13.8358 18 14.25V17.25C18 17.6642 17.6642 18 17.25 18H14.25C13.8358 18 13.5 17.6642 13.5 17.25C13.5 16.8358 13.8358 16.5 14.25 16.5H15.4393L12.9697 14.0303C12.6768 13.7374 12.6768 13.2626 12.9697 12.9697Z" fill="currentColor"/>
  </svg>
`;

const AspectIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3 3.75C3 3.33579 3.33579 3 3.75 3H20.25C20.6642 3 21 3.33579 21 3.75V20.25C21 20.6642 20.6642 21 20.25 21H3.75C3.33579 21 3 20.6642 3 20.25V3.75ZM4.5 4.5V19.5H19.5V4.5H4.5ZM6 6.75C6 6.33579 6.33579 6 6.75 6H9.75C10.1642 6 10.5 6.33579 10.5 6.75C10.5 7.16421 10.1642 7.5 9.75 7.5H8.56066L11.0303 9.96967C11.3232 10.2626 11.3232 10.7374 11.0303 11.0303C10.7374 11.3232 10.2626 11.3232 9.96967 11.0303L7.5 8.56066V9.75C7.5 10.1642 7.16421 10.5 6.75 10.5C6.33579 10.5 6 10.1642 6 9.75V6.75ZM12.9697 12.9697C13.2626 12.6768 13.7374 12.6768 14.0303 12.9697L16.5 15.4393V14.25C16.5 13.8358 16.8358 13.5 17.25 13.5C17.6642 13.5 18 13.8358 18 14.25V17.25C18 17.6642 17.6642 18 17.25 18H14.25C13.8358 18 13.5 17.6642 13.5 17.25C13.5 16.8358 13.8358 16.5 14.25 16.5H15.4393L12.9697 14.0303C12.6768 13.7374 12.6768 13.2626 12.9697 12.9697Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconName,

  IconComponent: AspectIcon,
  IconSvg: IconSvg
} as IconType;
